import { render, staticRenderFns } from "./TermsAndAgreementModal.vue?vue&type=template&id=3538a591&"
import script from "./TermsAndAgreementModal.vue?vue&type=script&lang=js&"
export * from "./TermsAndAgreementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports